import { useI18nContext } from "@i18n/i18n-react";
import { T } from "@i18n/T";
import { Checkbox } from "@shadcn/ui/checkbox";
import { Field, FieldLabel } from "@shadcn/ui/field";
import type { InvitationJoinProps } from "./AuthRoute";

/**
 * Opt-in control shown on the sign-in / sign-up screens when the user arrived via an
 * invitation link. Checked by default: leaving it on joins the inviting organization
 * automatically right after authentication. Unchecking it falls back to the normal flow.
 */
export const InvitationJoinCheckbox = (props: InvitationJoinProps) => {
	const { organizationName, checked, onCheckedChange } = props;
	const LL = useI18nContext().LL.auth;

	return (
		<Field orientation="horizontal">
			<Checkbox
				id="invitation-join"
				checked={checked}
				onCheckedChange={(value) => onCheckedChange(value === true)}
			/>
			<FieldLabel htmlFor="invitation-join" onClick={() => onCheckedChange(!checked)}>
				<span>
					<T>{LL.INVITATION_JOIN_CHECKBOX_LABEL({ organization: organizationName })}</T>
				</span>
			</FieldLabel>
		</Field>
	);
};
